import axios from "axios";

export const API_BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${API_BASE}/api`;

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("ssd_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function wsUrl(code) {
  const base = API_BASE.replace(/^http/, "ws");
  return `${base}/api/ws/${code}`;
}

export function formatErr(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").join(" ");
  return e?.message || "Bir hata oluştu";
}
